import { Routes } from '@angular/router';
import { authGuard } from '@core/guards/auth.guard';
import { loginGuard } from '@core/guards/login.guard';

import { MAIN_ROUTES } from '@core/pages/main-layout/main-layout.routes';
import { firebaseConfigResolver, mapLoaderResolver } from '@shared/services';
import { initializeApp, provideFirebaseApp } from '@angular/fire/app';
import { getFirestore, provideFirestore } from '@angular/fire/firestore';
import { getStorage, provideStorage } from '@angular/fire/storage';
import { getAuth, provideAuth } from '@angular/fire/auth';
import { GlobalService } from '@core/services/global.service';
import { environment } from '@envs/environment';

export const routes: Routes = [
  {
    path: 'authentication/login',
    loadComponent: () =>
      import('./core/pages/auth/login/login.component').then(
        m => m.LoginComponent
      ),
    resolve: { login: loginGuard },
  },
  {
    path: '',
    loadComponent: () =>
      import('@core/pages/main-layout/main-layout-wrapper.component').then(
        m => m.MainLayoutWrapperComponent
      ),
    resolve: { maps: mapLoaderResolver, firebase: firebaseConfigResolver },
    canActivate: [authGuard],
    providers: [
      provideFirebaseApp(injector => {
        const globalService = injector.get(GlobalService);
        return initializeApp({
          ...environment.firebaseConfig,
          apiKey: globalService.firebaseApiKey(),
        });
      }),
      provideAuth(() => getAuth()),
      provideFirestore(() => getFirestore()),
      provideStorage(() => getStorage()),
    ],
    children: [...MAIN_ROUTES],
  },
  {
    path: '**',
    redirectTo: '404',
    pathMatch: 'full',
  },
];
